/* Borrar si algun dia se actualiza este proyecto*/
/* eslint-disable react-hooks/exhaustive-deps */
/** Plantilla de Grid de DHX */
import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Grid as GridDHX, DataCollection } from "dhx-suite";

function Grid(props) {
  const {
    rowHeight,
    headerRowHeight,
    footerRowHeight,
    columns,
    editable,
    selection,
    multiselection,
    toggleClick,
    toggleDBClick,
    toggleSelected,
    onEdit,
    css,
    rowCss,
    hasSelected,
    selectedItem,
    onReady,
    dragItem
  } = props;

  const data = props.data ?? [];
  const GridRef = useRef();

  let grid = null;

  useEffect(() => {
    grid = new GridDHX(GridRef.current, {
      columns,
      editable,
      multiselection,
      selection,
      resizable: true,
      tooltip: false,
      rowHeight,
      footerRowHeight,
      headerRowHeight:headerRowHeight,
      autoWidth: true,
      rowCss: rowCss,
      css: 'epod5_grid ' + css + ((data && data.length < 15) ? ' low_data' : ''),
      dragItem: dragItem, // "column", "row", "both"
    });


    grid.data.parse(data);

    grid.events.on('beforeSelect', (row, column) => {
      row.cb = true;
    });

    grid.events.on('beforeUnSelect', (row, column) => {
      row.cb = false;
    });



    grid.events.on("cellClick", (row, column, e) => {
      toggleClick(column.id, row[column.id]);
      if (column.id === 'cb' && row.cb !== true) {
        grid.selection.removeCell(row.id);
      }
      toggleSelected(grid.selection.getCells());
    });

    grid.events.on("cellDblClick", (row, column, e) => {
      toggleDBClick(row, row[column.id]);
    });

    grid.events.on('afterEditEnd', (value, row, column) => {
      //ignoramos el cb
      if (column.id !== 'cb') {
        onEdit(row, column, value);

      }
    });

    if (hasSelected) {
      selectedItem.forEach(element => {
        let rowId = grid.data.getId(element.row.index);
        grid.selection.setCell(rowId, 'index', true);
      });
    }

    //esta funcion  es para agregar validaciones especiales
    onReady(grid);
    console.log(">>se monta el grid");

    return () => {
      try {
        grid.destructor();
      } catch (error) {}
    }
  }, []);


  return (
    <div id={props.id} style={{ width: "100%", height: "100%" }} ref={GridRef}></div>
  );
}
Grid.propTypes = {
  id: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.instanceOf(DataCollection)]),
  rowHeight: PropTypes.number,
  headerRowHeight: PropTypes.number,
  footerRowHeight: PropTypes.number,
  columns: PropTypes.array,
  editable: PropTypes.bool,
  selection: PropTypes.oneOf(["complex", "row", "cell"]),
  multiselection: PropTypes.bool,
  toggleDBClick: PropTypes.func,
  toggleSelected: PropTypes.func,
  onEdit: PropTypes.func,
  css: PropTypes.string,
  rowCss: PropTypes.string,
  hasSelected: PropTypes.bool,
  selectedItem: PropTypes.any,
  idAtributte: PropTypes.any,
  onReady: PropTypes.func,

};
Grid.defaultProps = {
  id: 'epod5_grid',
  data: [],
  rowHeight: 40,
  headerRowHeight: 45,
  footerRowHeight: 30,
  columns: [],
  editable: false,
  selection: 'row',
  multiselection: false,
  toggleClick: () => { },
  toggleDBClick: () => { },
  toggleSelected: () => { },
  onEdit: () => { },
  css: '',
  rowCss: '',
  hasSelected: false,
  selectedItem: {},
  onReady: () => { },

}

export default Grid;
